<template>
  <ElDialog
    :title="$t('APP.STATE_DESCRIPTIONS.TITLE')"
    :visible="value"
    width="30%"
    @close="emitInputEvent"
  >
    {{ $t('APP.STATE_DESCRIPTIONS.DESC') }}
    <ul>
      <li>
        <strong>{{ $t('APP.NEW') }}:</strong>
        <span v-dompurify-html="$t('APP.NEW.DESC')" />
      </li>
      <li>
        <strong>{{ $t('APP.PENDING') }}:</strong>
        <span v-dompurify-html="$t('APP.PENDING.DESC')" />
      </li>
      <li>
        <strong>{{ $t('APP.NEED_TO_CHANGE') }}:</strong>
        <span v-dompurify-html="$t('APP.NEED_TO_CHANGE.DESC')" />
      </li>
      <li>
        <strong>{{ $t('APP.REJECTED') }}:</strong>
        <span v-dompurify-html="$t('APP.REJECTED.DESC')" />
      </li>
      <li>
        <strong>{{ $t('APP.REMOVED') }}:</strong>
        <span v-dompurify-html="$t('APP.REMOVED.DESC')" />
      </li>
      <li>
        <strong>{{ $t('APP.READY_TO_PUBLISH') }}:</strong>
        <span v-dompurify-html="$t('APP.READY_TO_PUBLISH.DESC')" />
      </li>
      <li>
        <strong>{{ $t('APP.PUBLISHED') }}:</strong>
        <span v-dompurify-html="$t('APP.PUBLISHED.DESC')" />
      </li>
    </ul>
  </ElDialog>
</template>

<script>
export default {
  name: 'AppStateDescModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitInputEvent() {
      this.$emit('input', false);
    },
  },
};
</script>
